import * as React from 'react';

import '../Main.scss';
import './DestinationStep.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChevronRight } from '@awesome.me/kit-8a0d2fd588/icons/modules/classic/light';
import { faCheck } from '@awesome.me/kit-8a0d2fd588/icons/modules/classic/solid';

type DestinationCardProps = {
    icon: IconDefinition;
    heading: string;
    description?: string;
    selected: boolean;
    onSelect: () => void;
};

/**
 * A navigation card for a destination step (client, engagement). Clicking it selects and advances, so it accepts
 * only its first click until it unmounts: a double-click or a repeated Enter must not advance a second step.
 */
export const DestinationCard: React.FC<DestinationCardProps> = ({ icon, heading, description, selected, onSelect }): React.ReactElement => {
    const fired = React.useRef(false);

    const handleClick = (): void => {
        if (fired.current) {
            return;
        }
        fired.current = true;
        onSelect();
    };

    return (
        <button
            type={'button'}
            className={`cr-selectable-card cr-selectable-card--navigation${selected ? ' cr-selectable-card--selected' : ''}`}
            aria-current={selected ? 'true' : undefined}
            onClick={handleClick}
        >
            <div className={'cr-selectable-card__card-content'}>
                <div className={'cr-selectable-card__icon-container'}>
                    <FontAwesomeIcon icon={icon} />
                </div>
                <div className={'cr-selectable-card__content'}>
                    <div className={'cr-selectable-card__header'}>
                        <span className={'cr-selectable-card__heading'}>{heading}</span>
                    </div>
                    {description && <span className={'cr-selectable-card__description'}>{description}</span>}
                </div>
                {selected && <FontAwesomeIcon icon={faCheck} />}
                <FontAwesomeIcon icon={faChevronRight} className={'cr-selectable-card__chevron'} />
            </div>
        </button>
    );
};
